import Config from '../config';

class WishListService {
    constructor () {
        this.config = new Config();
        this.prodLevId = void(0);
    }

    toggleWishList (btnHeart) {
        let inList = btnHeart.hasClass('is-active');
        let method = inList ? 'remove' : 'add';
        let title = !inList ? 'Remove from wish list' : 'Add to wish list!';

        this.prodLevId = btnHeart.data('prodlevid');
        let url = `${this.config.getDomain()}/?action=wishlist/${method}&prodLevId=${this.prodLevId}`;
        if (window.csrf_token) {
            url = url + `&_token=${window.csrf_token}`;
        }

        return $.getJSON(url)
            .done(response => {
                if (response.result) {
                    btnHeart.attr('title', title);
                    btnHeart.toggleClass('is-active');
                }
            });
    }
}

export default WishListService;
